import { CardList } from 'components/elements/CardList';
import React from 'react';
import { Helmet } from 'react-helmet';
import Style from 'views/pages/PlanoDeDesenvolvimento.module.scss';
import { concursosESorteios } from 'assets/data/glampartnerConcursos.jsx';
import { tabuleiro } from 'assets/data/glampartnerConcursos.jsx';

import { connect } from 'react-redux';
import { Modal } from 'components/modal/Modal';

class PlanoDeDesenvolvimento extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      detailsModalVisible: false,
      currentDetails: null,
    };
  }

  // closeToggleDetailsModal = (item) => {
  //   this.setState({
  //     currentDetails: item,
  //     detailsModalVisible: !this.state.detailsModalVisible,
  //   });
  // }

  toggleDetailsModal = (item) => {
    // if( item.details.props.src != null){
    this.setState({
      currentDetails: item,
      detailsModalVisible: !this.state.detailsModalVisible,
   });
  // }
  //   else{
  //     this.setState({
  //       currentDetails: null,
  //       detailsModalVisible: false,
  //     });
  //   }
   
      
  };

  render() {
    const { currentDetails } = this.state;

    return (
      <div className={'p-2 p-lg-5'}>
        <Helmet>
          <title>Minha Glambox : Plano de Desenvolvimento</title>
        </Helmet>

        <h1>Plano de Desenvolvimento</h1>

        <div className={'p-2 p-lg-5'} style={{ background: '#fff', marginBottom: 30 }}>
        Queremos que você cresça junto com a gente! Por isso, temos um plano de desenvolvimento 
        perfeito para você aprimorar a sua carreira e crescer como uma influenciadora de beleza. 
        Veja abaixo o tabuleiro com todos os passos e incentivos do nosso programa.
        </div>


        <div className={Style['plano-container']}>
          <div className={Style['tabuleiro']}>
          <CardList
              className={Style['list-item-tabuleiro']}
              onClick={this.toggleDetailsModal}
              items={tabuleiro}
            />
            {/* <img
              src={'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_18548.png'}
              alt={'tabuleiro de plano de desenvolvimento'}
            /> */}
          </div>

          <div className={Style['list']}>
            <CardList
              className={Style['list-item']}
              onClick={this.toggleDetailsModal}
              items={concursosESorteios}
            />
          </div>
        </div>

       
        <Modal visible={this.state.detailsModalVisible} onCloseModal={this.toggleDetailsModal}>
          <div className={Style['details']}>
          </div>
        </Modal>
    
        
        
        <Modal visible={this.state.detailsModalVisible} onCloseModal={this.toggleDetailsModal}>
          <div className={Style['details']}>
            <h3 className={Style['title']}>{currentDetails && currentDetails.title}</h3>
            <div>{currentDetails && currentDetails.details}</div>
          </div>
        </Modal>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

PlanoDeDesenvolvimento = connect(mapStateToProps, mapDispatchToProps)(PlanoDeDesenvolvimento);

export { PlanoDeDesenvolvimento };
